import axios from "axios";

export const state = {
    reportcashpayments: [],
};

export const getters = {
    reportcashpayments: state => state.reportcashpayments,
};

export const mutations = {
    setReportCashPayments(reportcashpayments, newValue) { state.reportcashpayments = newValue},
};

export const actions = {
    fetchReportCashPayments({ commit }) {
        axios.get('/reportcashpayments').then(res => {
            commit('setReportCashPayments', res.data.payments)
        })
    },
    filterReportCashPayments({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportcashpayments";
        axios.post(url, formData).then((response) => {
            commit('setReportCashPayments', response.data.payments)
        })
    },
};
